export const PERCENT_BREACKPOINTS_BONANZA = [
  0,
  25,
  50,
  75,
  100,
].map((percentage) => ({ percentage, title: `${percentage}` }));
